import { SupportedApp } from "config/config";
import { useEffect, useState } from "react";

export const useApp = (app: SupportedApp) => {
    const [, setRefresh] = useState(0);

    // Trigger re-render of the component when app configuration is loaded
    useEffect(() => {
        const listener = () => setRefresh((t) => t + 1);
        app.subscribe(listener);
        if (app.enabled && !app.isLoaded()) {
            app.loadConfiguration();
        }

        return () => app.unsubscribe(listener);
    }, [app]);

    return app;
};
